
<div class="page-header d-flex align-items-center justify-content-between">
  <div class="d-flex align-items-center">
    <router-link to="/" tag="a" class="logo">
      <img src="../assets/logo.png" />
    </router-link>

    <slot></slot>
  </div>

  <div class="d-flex align-items-center">
    <div class="d-flex align-items-center">
      <slot name="right"></slot>
    </div>

    <div class="currentUser ml-2 d-none">
      <div>
        <strong>{{ userStore.user.shortName }}</strong>
      </div>
    </div>

    <div class="currentUser ml-2" @click="logout" v-if="authMode === 'azuread'">
      <div>
        <strong>Logout</strong>
      </div>
    </div>

    <div class="hubStatus" v-if="!boardStore.hubStatus">
      <div class="connected" v-if="boardStore.hubStatus">Connected</div>
      <div class="disconnected" v-else>Disconnected</div>
    </div>
  </div>
</div>
